export default __webpack_public_path__ + "064d00f1b92b2dfc5114b21f52b18697.png";